import React, { memo } from 'react';
import WebsiteFilters from 'components/filters/WebsiteFilters';

export const CarouselsFilters = memo(
  ({
    onFiltersChange,
    shoppingCenters = [],
    loadingCompanies = false,
    filters = {},
  }) => {
    return (
      <WebsiteFilters
        shoppingCenters={shoppingCenters}
        onFiltersChange={onFiltersChange}
        loading={loadingCompanies}
        filters={filters}
        showInsegna={false}
        showCategorie={false}
        enableSorting={true}
        showSearch={false}
      />
    );
  },
);
